import { useAppContext } from "AppContextProvider";
import { ErrorHandler } from "components/ErrorHandler";
import { LoadingScreen } from "components/LoadingScreen";
import { Account } from "data/interfaces";
import NotFoundPage from "features/notFoundPage/NotFoundPage";
import RolesPage from "features/rolesPage/RolesPage";
import UsersPage from "features/usersPage/UsersPage";
import { useEffect, useState } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { ApiService, Error } from "services";

export default function AccountRoutes() {
  const { accountId } = useParams();
  const { state, setState } = useAppContext();

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error>();

  useEffect(() => {
    ApiService.getAccounts()
      .then((accounts: Account[]) => {
        const activeAccount = accounts.find((a) => a.accountId === accountId);

        if (activeAccount) setState({ accounts, activeAccount });

        setLoading(false);
      })
      .catch((error: Error) => setError(error));
  }, [accountId, setState]);

  return (
    <ErrorHandler error={error}>
      {loading && <LoadingScreen title="Loading..." />}
      {!loading &&
        (state.activeAccount ? (
          <Routes>
            <Route path="users" element={<UsersPage />} />
            <Route path="roles" element={<RolesPage />} />
          </Routes>
        ) : (
          <NotFoundPage />
        ))}
    </ErrorHandler>
  );
}
